export interface TimeframeModel {
    value: number;
    unit: string;
}

export function getAdditionalPricePerCharacter(availableUse: { basePrice: number; basePriceCharacters: number }) {
    return Math.floor(availableUse.basePrice * 100 / availableUse.basePriceCharacters) / 100;
}

export function calculatePriceForRecording(
    recording: { takes: { isChecked: boolean; text: string }[] },
    availableUse: { basePrice: number; basePriceCharacters: number },
    includedTakes = 1,
) {
    const selectedTakes = recording.takes.filter(x => x.isChecked).length;
    if (selectedTakes === 0) {
        return { price: 0, averageTextLength: 0, variants: 0 };
    }

    const additionalPricePerCharacter = getAdditionalPricePerCharacter(availableUse);
    const factor = 1 + Math.max(0, selectedTakes - includedTakes) / 10;

    const averageTextLength = Math.floor(
        recording.takes.reduce((acc, x) => acc + x.text.length, 0) / recording.takes.length
    );
    const additionalPrice = Math.max(
        (averageTextLength - availableUse.basePriceCharacters) * additionalPricePerCharacter,
        0
    );

    return {
        price: (availableUse.basePrice + additionalPrice) * factor,
        averageTextLength,
        variants: selectedTakes - 1
    };
}

export function calculateUnifiedPrice(
    recordings: { takes: { text: string }[] }[],
    availableUse: { basePrice: number; basePriceCharacters: number },
) {
    const additionalPricePerCharacter = getAdditionalPricePerCharacter(availableUse);
    const pricedRecordings = recordings.filter(recording => recording.takes.length > 0);
    const totalCharacters = pricedRecordings.reduce(
        (recordingsTotal, recording) =>
            recordingsTotal + recording.takes.reduce((takesTotal, take) => takesTotal + take.text.length, 0),
        0
    );
    const additionalCharacters = pricedRecordings.reduce((total, recording) => {
        const recordingCharacters = recording.takes.reduce((sum, take) => sum + take.text.length, 0);
        return total + Math.max(recordingCharacters - availableUse.basePriceCharacters, 0);
    }, 0);

    return {
        price: pricedRecordings.length * availableUse.basePrice + additionalCharacters * additionalPricePerCharacter,
        totalCharacters,
        includedCharacters: pricedRecordings.length * availableUse.basePriceCharacters,
        additionalCharacters
    };
}

export function calculateCheapestUnifiedPrice(
    recordings: { takes: { text: string }[] }[],
    availableUses: { basePrice: number; basePriceCharacters: number }[],
) {
    if (availableUses.length === 0) {
        return 0;
    }

    return Math.min(...availableUses.map(availableUse => calculateUnifiedPrice(recordings, availableUse).price));
}
